<template>
  <div class="mooc-login">
    <div class="browser-screen-loading-content" v-if="loader && credentials.client === ''">
      <div class="loading-dots dark-gray">
        <i></i>
        <i></i>
        <i></i>
        <i></i>
      </div>
    </div>


    <div class="cont login-container" v-if="!loader">
      <div class="form sign-in">
        <div class="logo_pass_digital">
          <img id="logo_client" v-if="credentials.client !== ''"  :class="credentials.client" class="hoc" onerror="this.src='./static/images/demo.png'" :src="'./static/images/'+credentials.client+'.png'">
        </div>

        <div class="alert alert-danger error-msg-container" v-if="error_api">
          <p>{{ error_api }}</p>
        </div>

        <!-- Loader container -->
        <div class="loader-container" :class="{hidden: !showLoader}">
          <div class="cs-loader">
            <div class="cs-loader-inner">
              <label> ●</label>
              <label> ●</label>
              <label> ●</label>
              <label> ●</label>
              <label> ●</label>
              <label> ●</label>
            </div>
          </div>
        </div>
        <!-- /Loader container -->



        <div class="mt-5" >
          <label for="email-field" v-bind:class="{'password-blocked' : passwordBlocked}" >
            <span>Nom d'utilisateur </span>
            <br>
            <input id="email-field" type="text" name="email" class="login-field" ref="emailField"
                   v-validate="'required'"
                   placeholder="Nom d'utilisateur" v-model="credentials.mail"  :disabled="passwordBlocked">
            <!--<span class="field-error" v-show="errors.has('email')"> Nom d'utilisateur vide </span>-->

          </label>
          <label for="password-field" v-bind:class="{'password-blocked' : passwordBlocked}">
            <span>Mot de passe</span>
            <br>
            <input id="password-field" type="password" name="password" class="login-field"
                   ref="passwordField"
                   placeholder="Mot de passe" v-model="credentials.password"
                   @keyup.enter="login"
                   :disabled="passwordBlocked">
            <!-- <span class="field-error" v-show="errors.has('password')"> Mot de passe vide </span>-->

          </label>

          <span class="field-error" v-show="passwordBlocked"> Le nombre de tentatives de saisie de votre mot de passe est atteint <br>
                    <countdown :time="countDown">
                        <template slot-scope="props"> <b>{{ props.hours }} : {{ props.minutes }} : {{ props.seconds }} </b></template>
                    </countdown>
                    </span>


        </div>
        <div class="my-2">
          <v-btn x-large color="#2FA284" class="submit" :disabled=" passwordBlocked" @click="login()" >Connectez-vous</v-btn>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
  import {HTTP} from '../core/http/http-common';
  import Routing from '../core/router/router';
  export default {
    name: "Login",
    data() {
      return {

        credentials: {
          mail: '',
          password: '',
          client: ''
        },
        showLoader: false,

        loader:true,
        error_api:false,

        passwordBlocked : false,
        countDown : 0


      }
    },

    created () {
      console.log("blockedPassword");
      this.blockedPassword();
      this.logo()

    },
    methods: {
      logo(){
        let self = this;
        HTTP.get(Routing.generate("api_configuration_get_status_client_config"))
          .then(function(response){
            if(response){
              self.credentials.client = response.data.data.client;
              self.loader=false;
            }
          },function(error){
            console.log(error)
          });
      }  ,

      blockedPassword(){
        var self =this;
        var tentaive_conexion = this.$session.get('user_blocked');
        if(tentaive_conexion >= 5 )
        {
          self.passwordBlocked =true;
          var date_now = new Date();
          if(!this.$session.get('user_time_blocked'))
          {
            var date = new Date();
            date.setHours(date.getHours() + 1);
            date.setMinutes(date.getMinutes() + 30);
            this.$session.set('user_time_blocked',date);
          }
          var date_blocked = this.$session.get('user_time_blocked');
          date_blocked = new Date(date_blocked);
          self.countDown = date_blocked.getTime() - date_now.getTime()
          if(self.countDown < 0 )
          {
            self.passwordBlocked =false;
            self.$session.destroy();
          }else
          {
            setTimeout(function(){ self.passwordBlocked =false;
              self.$session.destroy();}, self.countDown);
          }

        }
      },
      postlogin(){
        this.error_api=false;
        this.showLoader=true;

        var self = this;
        this.$session.start();
        var tentaive_conexion = 1;
        if (this.$session.get('user_blocked')) {
          tentaive_conexion = this.$session.get('user_blocked') + 1;
          this.$session.set('user_blocked', tentaive_conexion);
          if (tentaive_conexion == 5) {
            this.showLoader=true;
            this.blockedPassword();
          }
        }
        else {
          this.$session.set('user_blocked', tentaive_conexion);
        }




        HTTP.post(
          Routing.generate("post_login"),
          {username: this.credentials.mail,password:this.credentials.password})
          .then(
            function(response){


              console.log(response);
              self.$session.set('user', response.data.userData.user);
              self.$cookie.set('user', self.$session.id(), {expires: '1H'});
              self.$router.push({name: 'statusList'})

            },function(error){
              self.error_api= "Nom d'utilisateur ou Mot de passe invalide";
              self.showLoader=false;

              console.log(error)
            })


      },



      login() {

        let valid = true;
        this.error_api=false;
        if (this.credentials.mail === '') {
          this.$refs.emailField.focus();
          this.error_api = "Nom d'utilisateur vide";
          valid = false;
          return;
        }
        /* empty password field */
        if (this.credentials.password === '') {
          this.$refs.passwordField.focus();
          this.error_api ="Mot de passe vide";
          valid = false;
        }

        if(valid){
          this.postlogin();
        }
      }

    }
  }
</script>

<style scoped lang="scss">
  .mooc-login {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    font-family: 'Open Sans', Helvetica, Arial, sans-serif;
    background-size: 100%;
    background: #fbfbfb;
    background-repeat: no-repeat;
    flex-direction: column;

    .cont {
      background: #fff;
      border-radius: 5px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
      transition: all 0.3s cubic-bezier(.25, .8, .25, 1);
      overflow: hidden;
      position: relative;
      z-index: 2;
      &.login-container {
        width: 25%;
      }
      &.subscribe-container {
        width: 25%;
      }
    }

    input, button {
      border: none;
      outline: none;
      background: none;
      font-family: 'Open Sans', Helvetica, Arial, sans-serif;
    }

    .form {
      position: relative;
      height: 100%;
      transition: transform 1.2s ease-in-out;
      padding: 20px ;
    }

    .logo_pass_digital {
      text-align: center;
      img{
        max-width: 200px!important;
      }

    }

    button {
      display: block;
      margin: 0 auto;
      border-radius: 5px;
      color: #fff;
      font-size: 15px;
      cursor: pointer;
    }

    button:focus {
      outline: none !important;
    }

    h3 {
      width: 100%;
      font-size: 26px;
      text-align: center;
      margin: 5px 0;
      font-family: "Open Sans", Helvetica, Arial, sans-serif;
    }

    label {
      display: block;
      margin: 25px auto 0;
      text-align: left;
    }
    label span {
      font-size: 14px;
      color: #7F7F7F;
      font-weight: bold;
    }

    input {
      display: block;
      width: 100%;
      margin-top: 5px;
      padding-top: 10px;
      padding-bottom: 10px;
      padding-left: 7px;
      font-size: 16px;
      border: 1px solid rgba(0, 0, 0, 0.4);
      text-align: left;
    }

    input:focus {
      box-shadow: none;
      border-color: #2FA284;
    }

    .submit {
      width: 100%;
      margin-top: 10px;
      margin-bottom: 10px;
      border: none;
      color: #ededed;
      background: #2FA284;
      text-transform: uppercase;
    }

    .submit span {
      font-weight: bold;
      color: #2FA284;
    }

    .field-error {
      color: #eb5843;
      text-tra: none !important;
    }

    .error-msg-container {
      padding: 0!important;
      border: none;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #ededed;
      p {
        margin: 14px 0;
      }
    }

    .d-felx {
      display: flex !important;
    }

    .filed-container-left {
      width: 50%;
      margin-right: 5px;
    }

    .filed-container-right {
      width: 50%;
      margin-left: 5px;
    }

    .subscription-connexion-container {
      margin-top: 15px;
      margin-bottom: 20px;
      text-align: center;
    }

    .subscription-connexion-link {
      color: #2FA284;
      font-weight: bold;
    }

    .or-container {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 10px 0;
      .or-arrow {
        width: 40%;
        height: 2px;
        background: #d7d7d7;
      }
      .or-text {
        width: 20%;
        text-align: center;
        text-transform: uppercase;
        color: #2FA284;
      }
    }

  }





  /* loader*/

  .loader-container {
    height: 20px;
    &.hidden {
      display: none;
    }
  }
  .cs-loader {
    position: relative;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }

  .cs-loader-inner {
    transform: translateY(-50%);
    top: 50%;
    position: absolute;
    color: #2FA284;
    padding-left: calc(50% - 45px);
    text-align: center;
  }

  .cs-loader-inner label {
    font-size: 20px;
    opacity: 0;
    display:inline-block;
  }

  @keyframes lol {
    0% {
      opacity: 0;
      transform: translateX(-300px);
    }
    33% {
      opacity: 1;
      transform: translateX(0px);
    }
    66% {
      opacity: 1;
      transform: translateX(0px);
    }
    100% {
      opacity: 0;
      transform: translateX(300px);
    }
  }

  @-webkit-keyframes lol {
    0% {
      opacity: 0;
      -webkit-transform: translateX(-300px);
    }
    33% {
      opacity: 1;
      -webkit-transform: translateX(0px);
    }
    66% {
      opacity: 1;
      -webkit-transform: translateX(0px);
    }
    100% {
      opacity: 0;
      -webkit-transform: translateX(300px);
    }
  }

  .cs-loader-inner label:nth-child(6) {
    -webkit-animation: lol 3s infinite ease-in-out;
    animation: lol 3s infinite ease-in-out;
  }

  .cs-loader-inner label:nth-child(5) {
    -webkit-animation: lol 3s 100ms infinite ease-in-out;
    animation: lol 3s 100ms infinite ease-in-out;
  }

  .cs-loader-inner label:nth-child(4) {
    -webkit-animation: lol 3s 200ms infinite ease-in-out;
    animation: lol 3s 200ms infinite ease-in-out;
  }

  .cs-loader-inner label:nth-child(3) {
    -webkit-animation: lol 3s 300ms infinite ease-in-out;
    animation: lol 3s 300ms infinite ease-in-out;
  }

  .cs-loader-inner label:nth-child(2) {
    -webkit-animation: lol 3s 400ms infinite ease-in-out;
    animation: lol 3s 400ms infinite ease-in-out;
  }

  .cs-loader-inner label:nth-child(1) {
    -webkit-animation: lol 3s 500ms infinite ease-in-out;
    animation: lol 3s 500ms infinite ease-in-out;
  }


  .browser-screen-loading-content {
    text-align: center;
    height: 100%;
    max-width: 100%;
    position: relative;
    top: 0;
    right: 0;
    bottom: 3em;
    left: 0;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .loading-dots {
    margin-left: -1.5em;
    opacity: 0;
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
    filter: alpha(opacity=0);
    -webkit-animation: loading-dots-fadein .5s linear forwards;
    -moz-animation: loading-dots-fadein .5s linear forwards;
    -o-animation: loading-dots-fadein .5s linear forwards;
    -ms-animation: loading-dots-fadein .5s linear forwards;
    animation: loading-dots-fadein .5s linear forwards;
  }
  .loading-dots i {
    width: .5em;
    height: .5em;
    display: inline-block;
    vertical-align: middle;
    background: #e0e0e0;
    -webkit-border-radius: 50%;
    border-radius: 50%;
    margin: 0 .125em;
    -webkit-animation: loading-dots-middle-dots .5s linear infinite;
    -moz-animation: loading-dots-middle-dots .5s linear infinite;
    -o-animation: loading-dots-middle-dots .5s linear infinite;
    -ms-animation: loading-dots-middle-dots .5s linear infinite;
    animation: loading-dots-middle-dots .5s linear infinite;
  }
  .loading-dots.dark-gray i {
    background: #707070;
  }
  .loading-dots i:first-child {
    -webkit-animation: loading-dots-first-dot .5s infinite;
    -moz-animation: loading-dots-first-dot .5s linear infinite;
    -o-animation: loading-dots-first-dot .5s linear infinite;
    -ms-animation: loading-dots-first-dot .5s linear infinite;
    animation: loading-dots-first-dot .5s linear infinite;
    opacity: 0;
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
    filter: alpha(opacity=0);
    -webkit-transform: translate(-1em);
    -moz-transform: translate(-1em);
    -o-transform: translate(-1em);
    -ms-transform: translate(-1em);
    transform: translate(-1em);
  }
  .loading-dots i:last-child {
    -webkit-animation: loading-dots-last-dot .5s linear infinite;
    -moz-animation: loading-dots-last-dot .5s linear infinite;
    -o-animation: loading-dots-last-dot .5s linear infinite;
    -ms-animation: loading-dots-last-dot .5s linear infinite;
    animation: loading-dots-last-dot .5s linear infinite;
  }


  @-moz-keyframes loading-dots-fadein{100%{opacity:1;-ms-filter:none;filter:none}}
  @-webkit-keyframes loading-dots-fadein{100%{opacity:1;-ms-filter:none;filter:none}}
  @-o-keyframes loading-dots-fadein{100%{opacity:1;-ms-filter:none;filter:none}}
  @keyframes loading-dots-fadein{100%{opacity:1;-ms-filter:none;filter:none}}

  @-moz-keyframes loading-dots-first-dot{100%{-webkit-transform:translate(1em);-moz-transform:translate(1em);-o-transform:translate(1em);-ms-transform:translate(1em);transform:translate(1em);opacity:1;-ms-filter:none;filter:none}}
  @-webkit-keyframes loading-dots-first-dot{100%{-webkit-transform:translate(1em);-moz-transform:translate(1em);-o-transform:translate(1em);-ms-transform:translate(1em);transform:translate(1em);opacity:1;-ms-filter:none;filter:none}}
  @-o-keyframes loading-dots-first-dot{100%{-webkit-transform:translate(1em);-moz-transform:translate(1em);-o-transform:translate(1em);-ms-transform:translate(1em);transform:translate(1em);opacity:1;-ms-filter:none;filter:none}}
  @keyframes loading-dots-first-dot{100%{-webkit-transform:translate(1em);-moz-transform:translate(1em);-o-transform:translate(1em);-ms-transform:translate(1em);transform:translate(1em);opacity:1;-ms-filter:none;filter:none}}


  @-moz-keyframes loading-dots-middle-dots{100%{-webkit-transform:translate(1em);-moz-transform:translate(1em);-o-transform:translate(1em);-ms-transform:translate(1em);transform:translate(1em)}}
  @-webkit-keyframes loading-dots-middle-dots{100%{-webkit-transform:translate(1em);-moz-transform:translate(1em);-o-transform:translate(1em);-ms-transform:translate(1em);transform:translate(1em)}}
  @-o-keyframes loading-dots-middle-dots{100%{-webkit-transform:translate(1em);-moz-transform:translate(1em);-o-transform:translate(1em);-ms-transform:translate(1em);transform:translate(1em)}}
  @keyframes loading-dots-middle-dots{100%{-webkit-transform:translate(1em);-moz-transform:translate(1em);-o-transform:translate(1em);-ms-transform:translate(1em);transform:translate(1em)}}


  @-moz-keyframes loading-dots-last-dot{100%{-webkit-transform:translate(2em);-moz-transform:translate(2em);-o-transform:translate(2em);-ms-transform:translate(2em);transform:translate(2em);opacity:0;-ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";filter:alpha(opacity=0)}}
  @-webkit-keyframes loading-dots-last-dot{100%{-webkit-transform:translate(2em);-moz-transform:translate(2em);-o-transform:translate(2em);-ms-transform:translate(2em);transform:translate(2em);opacity:0;-ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";filter:alpha(opacity=0)}}
  @-o-keyframes loading-dots-last-dot{100%{-webkit-transform:translate(2em);-moz-transform:translate(2em);-o-transform:translate(2em);-ms-transform:translate(2em);transform:translate(2em);opacity:0;-ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";filter:alpha(opacity=0)}}
  @keyframes loading-dots-last-dot{100%{-webkit-transform:translate(2em);-moz-transform:translate(2em);-o-transform:translate(2em);-ms-transform:translate(2em);transform:translate(2em);opacity:0;-ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";filter:alpha(opacity=0)}}

</style>



// WEBPACK FOOTER //
// src/components/Login.vue